import '@babel/polyfill';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import { Tabs, Tab } from 'vue-tabs-component';
import VuePaginate from 'vue-paginate';
import { sync } from 'vuex-router-sync';
import VueModal from 'vue-js-modal';
import App from './App';
import router from './router';
import store from './store/index';
import InlineFieldActions from './components/fields/InlineFieldActions';
import fieldCustomCheckbox from './components/fields/fieldCustomCheckbox';
import fieldCustomChecklist from './components/fields/fieldCustomChecklist';
import fieldCustomInput from './components/fields/fieldCustomInput';
import fieldCustomNoUiSlider from './components/fields/fieldCustomNoUiSlider';
import fieldCustomRadios from './components/fields/fieldCustomRadios';
import fieldCustomSelect from './components/fields/fieldCustomSelect';
import fieldButton from './components/fields/fieldButton';
import fieldCustomSubmit from './components/fields/fieldCustomSubmit';
import fieldCustomTextArea from './components/fields/fieldCustomTextArea';
import fieldDuration from './components/fields/fieldDuration';
import fieldFileUpload from './components/fields/fieldFileUpload';
import fieldFlatpickr from './components/fields/fieldFlatpickr';
import fieldMultipleInput from './components/fields/fieldMultipleInput';
import fieldOpinionScale from './components/fields/fieldOpinionScale';
import fieldOpinionRange from './components/fields/fieldOpinionRange';
import fieldStaticText from './components/fields/fieldStaticText';
import './assets/styles/main.scss';

Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('InlineFieldActions', InlineFieldActions);
Vue.component('fieldCustomCheckbox', fieldCustomCheckbox);
Vue.component('fieldCustomChecklist', fieldCustomChecklist);
Vue.component('fieldCustomInput', fieldCustomInput);
Vue.component('fieldCustomNoUiSlider', fieldCustomNoUiSlider);
Vue.component('fieldCustomRadios', fieldCustomRadios);
Vue.component('fieldCustomSelect', fieldCustomSelect);
Vue.component('fieldButton', fieldButton);
Vue.component('fieldCustomSubmit', fieldCustomSubmit);
Vue.component('fieldCustomTextArea', fieldCustomTextArea);
Vue.component('fieldDuration', fieldDuration);
Vue.component('fieldFileUpload', fieldFileUpload);
Vue.component('fieldFlatpickr', fieldFlatpickr);
Vue.component('fieldMultipleInput', fieldMultipleInput);
Vue.component('fieldOpinionScale', fieldOpinionScale);
Vue.component('fieldOpinionRange', fieldOpinionRange);
Vue.component('fieldStaticText', fieldStaticText);

Vue.use(VueFormGenerator);
Vue.use(VuePaginate);
Vue.use(VueModal, { dialog: true });

sync(store, router);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  render: (h) => h(App),
});
